import { MutationHookOptions, useMutation } from '@apollo/client';
import {
  UpsertNoteMutation,
  UpsertNoteMutationVariables,
} from '../gql/graphql';

import { GET_NOTES } from './notes.query';
import { graphql } from '../gql';

export const UPSERT_NOTE = graphql(`
  mutation upsertNote($details: NoteInput!) {
    upsertNote(details: $details) {
      uuid
      note
      categories
      label
      targetType
      targetName
      targetUuid
      tenant
      createdAt
      updatedAt
    }
  }
`);

export function useUpsertNoteMutation(
  options: MutationHookOptions<
    UpsertNoteMutation,
    UpsertNoteMutationVariables
  > = {}
) {
  const [upsertNote, { loading, error, reset }] = useMutation(UPSERT_NOTE, {
    refetchQueries: [GET_NOTES],
    awaitRefetchQueries: true,
    ...options,
  });

  return {
    upsertNote,
    loading,
    error,
    reset,
  };
}
